import { ErrorSidePanel } from '@/components/errors';
import { personalInfoQueryOptions } from '@/hooks/api';
import { downloadTextFile, loadHistoryState } from '@/lib';
import {
  ErrorCodes,
  ModuleName,
  Screen,
  type SkinPageConfig,
  templates,
  useI18n,
  useToast,
} from '@nosinovacao/nosid-mfe-common';
import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { mfaRecoveryCodesFlowSchema } from '../../../-model/flow';
import { type CompleteProps } from './-model/props';
import { CompleteLight } from './-skins';

const KEY_PREFIX = 'Security.AuthenticatorAppCard.Setup.Complete';
const RECOVERY_CODES_FILE_NAME = 'nos-id-recovery-codes.txt';

export const Route = createFileRoute('/(security)/security/_mfa-setup/authenticator-app/complete/')(
  {
    component: RouteComponent,
    errorComponent: ErrorSidePanel,
    staticData: {
      module: ModuleName.Security,
      screen: Screen.SetupComplete,
      setupStep: {
        number: 4,
        titleKey: `${KEY_PREFIX}.Title`,
        subtitleKey: `${KEY_PREFIX}.Description`,
      },
    },
    loader: loadHistoryState(mfaRecoveryCodesFlowSchema, { errorCode: ErrorCodes.AccessDenied }),
  },
);

function RouteComponent() {
  const { RecoveryCodes } = Route.useLoaderData();
  const navigate = Route.useNavigate();
  const client = useQueryClient();
  const toast = useToast();
  const { t } = useI18n();
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);

  const props: CompleteProps = {
    codes: RecoveryCodes,
    confirmed,
    setConfirmed,
    loading,
    download: () => {
      downloadTextFile(RECOVERY_CODES_FILE_NAME, RecoveryCodes.join('\n'));
    },
    // ? activate does not return the device or activation date, so the card has to be refetched
    finish: () => {
      setLoading(true);
      client.invalidateQueries(personalInfoQueryOptions).finally(() => {
        setLoading(false);
        toast.show('success', t('Common.SnackBar.AuthenticatorAppEnabled'));
        navigate({ to: '/security' });
      });
    },
  };

  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: CompleteProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <CompleteLight {...props} />,
  };
}
